import React from 'react';
import PropTypes from 'prop-types';

import CodeDisplay from 'common/components/CodeDisplay';
import { isDesktop } from 'common/deviceDetection';

import styles from './index.module.css';

const OffRampLinkDetails = ({ offRampUrl }) => (
  <div className={styles.codeDisplay}>
    {isDesktop() ? (
      <CodeDisplay code={offRampUrl} fullWidth clipboard truncated shareable />
    ) : (
      <CodeDisplay
        code={offRampUrl}
        shareable
        shareText={`Use this link to continue your off ramp process: ${offRampUrl}`}
        shareUrl={offRampUrl}
        fullWidth
      />
    )}
  </div>
);

OffRampLinkDetails.propTypes = {
  offRampUrl: PropTypes.string.isRequired,
};

export default OffRampLinkDetails;
